import { ReactElement } from 'react';

import { kebabCase, map } from 'lodash/fp';
import { ValueLabel } from '..';
import { FormControl, Select, MenuItem, styled } from '@mui/material';

export const SelectNav = ({
  labels,
  currentTab,
  onChange,
  ariaLabel,
}: {
  labels: ValueLabel<number>[];
  currentTab: number;
  onChange: (a: number) => void;
  ariaLabel: string;
}) => {
  return (
    <FormContro aria-label={ariaLabel}>
      <h3 id="label">Area: </h3>
      <Selec
        value={currentTab}
        onChange={e => onChange(e.target.value as number)}
        displayEmpty
        // inputProps={{ 'aria-label': 'Without label' }}
        labelId="label">
        {map<{ label: string; value: number }, ReactElement>(
          ({ label, value }) => (
            <MenuItem key={label} value={value}>
              <span id={kebabCase(label)}>{label}</span>
            </MenuItem>
          )
        )(labels)}
      </Selec>
    </FormContro>
  );
};

const FormContro = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 120,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
}));

const Selec = styled(Select)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
